export default "<app-barter-layout>\n\n</app-barter-layout>"